import { render } from "./Upgrade.vue?vue&type=template&id=137889f5&scoped=true"
import script from "./Upgrade.vue?vue&type=script&lang=js"
export * from "./Upgrade.vue?vue&type=script&lang=js"

import "./Upgrade.vue?vue&type=style&index=0&id=137889f5&scoped=true&lang=css"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137889f5"]])

export default __exports__